import { GatsbyImage } from "gatsby-plugin-image";

import { Box, Text } from "@vinomofo/components";

import { StorefrontImage } from "../../types";

export type ImageBlockProps = {
  caption?: string;
  image: StorefrontImage;
};

export const ImageBlock = ({
  image,
  caption,
}: ImageBlockProps): JSX.Element => {
  return (
    <Box
      textAlign="center"
      marginBottom={caption ? 20 : 0}
      as="figure"
      mx={[-20, 0]}
      overflow="hidden"
      maxHeight={image.width / image.height < 1 ? 900 : "auto"}
    >
      <GatsbyImage
        alt={`Image of ${caption}`}
        image={image}
        style={{
          maxWidth: 1700,
          marginLeft: "auto",
          marginRight: "auto",
          display: "block",
        }}
      />
      {caption && (
        <Box
          position="relative"
          top={-23}
          px="16px"
          py="8px"
          backgroundColor="primary"
          maxWidth="80%"
          display="inline-block"
          as="figcaption"
          alignItems="center"
        >
          <Text color="white" variant="sm">
            {caption}
          </Text>
        </Box>
      )}
    </Box>
  );
};
